import { render } from "./Time4WellbeingPrivacyPolicy.vue?vue&type=template&id=537a5e94"
import script from "./Time4WellbeingPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./Time4WellbeingPrivacyPolicy.vue?vue&type=script&lang=js"

import "./Time4WellbeingPrivacyPolicy.vue?vue&type=style&index=0&id=537a5e94&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__